import { ConfigInstanceToken } from '../../interfaces/config.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';

export class RecipientListModelOptions {
    public readonly maxEntries: number;
    public readonly maxSelections: number;
    public constructor({ maxEntries = Infinity, maxSelections = Infinity } = {}) {
        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigInstanceToken);

        this.maxEntries = isFinite(maxEntries) ? maxEntries : configService.getMaxRecipientEntries();
        this.maxSelections = isFinite(maxSelections) ? maxSelections : configService.getMaxRecipientEntries();
    }
}

export class RecipientListModelOptionsFromJson extends RecipientListModelOptions {
    public constructor() {
        super();
    }
}

export interface JsonRecipientListModelOptions {
    maxEntries: number;
    maxSelections: number;
}
